import Axios from "axios";

import { 
  SET_TAX_REGISTER_LIST, 
  UNSET_TAX_REGISTER_LIST,
  SET_TAX_PAYMENT_RECORD,
  UNSET_TAX_PAYMENT_RECORD,
  SET_TAX_PAYMENT_DETAILS,
  UNSET_TAX_PAYMENT_DETAILS,
} from "@/store/mutation-types";


import {
  getTaxRegister as getTaxRegisterApi,
  taxPayout as taxPayoutApi,
  taxPaymentList as taxPaymentListApi,
  taxChallanInfoStore as taxChallanInfoStoreApi,
  taxPaymentDetails as taxPaymentDetailsApi,
} from "@/store/api";

const state = {
  getTaxRegisterList: [],
  getTaxPaymentList: [],
  getTaxPaymentDetails: [],
};


const getters = {
  getTaxRegisterList(state) {
    return state.getTaxRegisterList;
  },
  getTaxPaymentList(state) {
    return state.getTaxPaymentList;
  },
  getTaxPaymentDetails(state) {
    return state.getTaxPaymentDetails;
  },
};


// Mutations
const mutations = {
  [SET_TAX_REGISTER_LIST](state, data) {
    state.getTaxRegisterList = data;
  },
  [UNSET_TAX_REGISTER_LIST](state) {
    state.getTaxRegisterList = [];
  },
  [SET_TAX_PAYMENT_RECORD](state, data) {
    state.getTaxPaymentList = data;
  },
  [UNSET_TAX_PAYMENT_RECORD](state) {
    state.getTaxPaymentList = [];
  },
  [SET_TAX_PAYMENT_DETAILS](state, data) {
    state.getTaxPaymentDetails = data;
  },
  [UNSET_TAX_PAYMENT_DETAILS](state) {
    state.getTaxPaymentDetails = [];
  },
};

// Actions
const actions = {
  getTaxPaymentDetails({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.get(`${taxPaymentDetailsApi}`, { params: data })
        .then((response) => {
          commit(SET_TAX_PAYMENT_DETAILS, response.data || {});
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_TAX_PAYMENT_DETAILS);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },
  getTaxRegisterList({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });

    return new Promise((resolve, reject) => {
      Axios.get(`${getTaxRegisterApi}`, { params: data })
        .then((response) => {
          commit(SET_TAX_REGISTER_LIST, response.data.data || []);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_TAX_REGISTER_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  getTaxPaymentList({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });

    return new Promise((resolve, reject) => {
      Axios.get(`${taxPaymentListApi}`, { params: data })
        .then((response) => {
          commit(SET_TAX_PAYMENT_RECORD, response.data.data || []);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_TAX_PAYMENT_RECORD);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  storeTaxPayout({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(taxPayoutApi, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  storeTaxChallanInfo({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(taxChallanInfoStoreApi, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },
};


export default {
  state,
  getters,
  actions,
  mutations,
};